import { GET_INFROM_CUSTOMER } from '@/app/_libs/utils/constants/endpoints';
import { useMutation } from '@tanstack/react-query';

async function updateCustomerInform({ token, id }) {
  try {
    const res = await fetch(`${GET_INFROM_CUSTOMER}`, {
      method: 'POST',
      body: JSON.stringify({ price_id: id }),
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }),
    });
    const resInfo = await res.json();
    return resInfo;
  } catch (error) {
    throw error;
  }
}

const useUpdateInformCustomer = () => {
  return useMutation({
    mutationFn: ({ token, id }) => updateCustomerInform({ token, id }),
  });
};
export { useUpdateInformCustomer };
